var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"orders-view"},[_c('transition',{attrs:{"name":"page-fade-up","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":"OrdersContainer"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }